import { render, staticRenderFns } from "./ex-area-list.vue?vue&type=template&id=c906d9ea&scoped=true&"
import script from "./ex-area-list.vue?vue&type=script&lang=js&"
export * from "./ex-area-list.vue?vue&type=script&lang=js&"
import style0 from "./ex-area-list.vue?vue&type=style&index=0&id=c906d9ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c906d9ea",
  null
  
)

export default component.exports